import React from "react";
import EntityBadges from "./EntityBadges";
import { AppearanceHandle } from "../Appearance";
import "./EntityIdentity.css";

/**
 * Canonical Entity Identity — Organization / Creator / Project / Donation.
 * Name, handle, type label, and badges share one implementation and Appearance tokens.
 * Do not duplicate this markup on entity or donation surfaces.
 *
 * variant="profile" — Organization / entity profile pages (default)
 * variant="checkout" — Donation checkout layout (width, sizing, wrap only)
 */
function EntityIdentity({
  name,
  handle,
  typeLabel,
  entity,
  badges,
  nameAs = "h1",
  nameId,
  variant = "profile",
  className = "",
}) {
  const displayName = name || "";
  const NameTag = nameAs === "h2" ? "h2" : nameAs === "p" ? "p" : "h1";
  const showCategory =
    (typeLabel && String(typeLabel).trim() !== "") ||
    (Array.isArray(badges) && badges.length > 0) ||
    !!entity;
  const variantClass =
    variant === "checkout" ? " org-identity--checkout" : " org-identity--profile";

  return (
    <div
      className={
        "org-identity" +
        variantClass +
        (className ? " " + className : "")
      }
    >
      {displayName ? (
        <NameTag id={nameId || undefined} className="org-name">
          {displayName}
        </NameTag>
      ) : null}
      {handle ? (
        <AppearanceHandle
          handle={handle}
          as="p"
          block
          className="org-handle"
        />
      ) : null}
      {showCategory ? (
        <p className="org-category">
          {typeLabel ? <span className="org-type">{typeLabel}</span> : null}
          <EntityBadges
            entity={entity}
            badges={badges}
            className="org-badges"
          />
        </p>
      ) : null}
    </div>
  );
}

export default EntityIdentity;
